import { useContext, useMemo } from 'react';

import { useBrand } from '@/contexts/brand/BrandContext';

import { AuthStrategyContext } from './AuthStrategyContext';
import { AUTH_STRATEGY_NOT_READY_MESSAGE } from './constants';
import type { AuthStrategyContextValue } from './types';

// gloss
export const useAuthStrategy = (): AuthStrategyContextValue => {
  const context = useContext(AuthStrategyContext);
  const { brand } = useBrand();

  const defaultContext = useMemo<AuthStrategyContextValue>(() => {
    if (!brand?.uuid) {
      return {
        strategy: null,
        handleAuth: () => Promise.reject(new Error(AUTH_STRATEGY_NOT_READY_MESSAGE)),
      };
    }
    return {
      strategy: {
        type: 'otp',
        primaryColor: brand.brandConfig?.primaryColor ?? undefined,
      },
      handleAuth: () => Promise.reject(new Error('OTP provider not mounted - wrap in AuthStrategyProvider')),
    };
  }, [brand?.uuid, brand?.brandConfig?.primaryColor]);

  return context ?? defaultContext;
};
